import styled from 'styled-components'

export const Icon = styled.img`
height: 30px;
width: 30px;
position: relative;
transform: ${({ transform }) => transform};
`;